import { getAppConfig } from '@wolffun/app-config';
const {
  env,
  isInternal,
  appVersion,
  sentryAuthToken
} = getAppConfig().general;
export const INTERNAL = isInternal;
export const ENV = env;
export const VERSION = appVersion;
export const SENTRY_AUTH_TOKEN = sentryAuthToken;